import React from 'react'
import BaseInput, { CommonInputProps } from './BaseInput'
import { useTranslation } from 'react-i18next'

interface BaseInputProps extends CommonInputProps {
	value: string | undefined
	onChange?: (value: string) => void
}

const EmailInput: React.FC<BaseInputProps> = ({
	value,
	onChange,
	readonly,
}: BaseInputProps): JSX.Element => {
	const { t } = useTranslation('common')

	const handleChange = (value: string | number | undefined) => {
		if (!onChange) return
		if (value) {
			onChange(value.toString())
		} else {
			onChange('')
		}
	}

	return (
		<BaseInput
			readonly={readonly}
			label={t('email')}
			value={value}
			onChange={handleChange}
			type='email'
		/>
	)
}

export default EmailInput
